import { hasModule, type SessionPrincipal } from "@/lib/auth";

// Who sees Commercie → Tarieven: billing, and whoever changes or approves a price agreement (docs/tms-facturatie.md §24.10).
export function mayReadTariffs(session: SessionPrincipal): boolean {
  return (
    session.roles.includes("admin") ||
    hasModule(session, "billing") ||
    hasModule(session, "billing_write") ||
    hasModule(session, "price_agreements_write") ||
    hasModule(session, "price_agreements_approve")
  );
}
